// react
import React, { Component, PropTypes } from "react"
// material-ui
import { Card, CardActions, CardHeader, CardText } from "material-ui/Card"
import { Table } from "material-ui/Table"
// app
import Add from "./add.js"
import Edit from "./edit.js"
import AddEditRemove from "components/common/buttons/AddEditRemove"
import TableHeader from "./table-header.js"
import TableBody from "./table-body.js"
import SaveCancel from "components/common/buttons/SaveCancel"


const initialState = {
    add: false,
    edit: false,
    selectedRow: false,
    error: false,
    rating: "",
    rank: "",
    hours: "",
    valid: "",
    rate: ""
}


class PersonRating extends Component {
    constructor(props) {
        super()
        this.state = initialState

        this.add = () => this.setState({ add: true })
        this.cancel = () => this.setState(initialState)
        
        this.save = this.save.bind(this)
        this.edit = this.edit.bind(this)
        this.remove = this.remove.bind(this)
        this.onRowSelection = this.onRowSelection.bind(this)

        this.onRatingChange = rating => this.setState({ rating })
        this.onRatingError = error => this.setState({ error })
        this.onRankChange = rank => this.setState({ rank })
        this.onHoursChange = hours => this.setState({ hours })
        this.onValidChange = valid => this.setState({ valid })
        this.onRateChange = rate => this.setState({ rate })
    }

    save() {
        if (this.state.add === true)
            this.props.onAdd(this.state)
        else
            this.props.onEdit(this.state)

        this.setState(initialState)
    }

    edit() {
        if (this.state.selectedRow === false) return
        const rating = this.props.data.get(this.state.selectedRow)
        this.setState({
            edit: true,
            id: rating.get("id"),
            rating: rating.get("rating"),
            rank: rating.get("rank"),
            hours: rating.get("hours"),
            valid: rating.get("valid"),
            rate: rating.get("rate")
        })
    }

    remove() {
        if (this.state.selectedRow === false) return
        const rating = this.props.data.get(this.state.selectedRow)
        this.props.onRemove(rating.get("id"))
        this.setState(initialState)
    }

    onRowSelection(rows) {
        const row = (typeof rows[0] === "number") ? (rows[0]) : false
        this.setState({ selectedRow: row })
    }

    render() {
        const { data, type } = this.props
        const { selectedRow } = this.state

        return (
            <Card className="card">
                <CardHeader
                    title="Rating"
                    style={{ paddingBottom: 0 }}
                />
                <CardText>
                { data.size > 0 ?
                    <Table onRowSelection={ this.onRowSelection }>
                        { TableHeader({ type }) }
                        { TableBody({ data, selectedRow, type }) }
                    </Table> 
                    : null
                }
                { this.state.add ?
                    <Add
                        type={ type }
                        onRatingChange={ this.onRatingChange }
                        onRatingError={ this.onRatingError }
                        onRankChange={ this.onRankChange }
                        onHoursChange={ this.onHoursChange }
                        onValidChange={ this.onValidChange }
                        onRateChange={ this.onRateChange }
                    />
                    :
                    null
                }
                { this.state.edit ?
                    <Edit
                        type={ type }
                        rating={ this.state.rating }
                        rank={ this.state.rank }
                        hours={ this.state.hours }
                        valid={ this.state.valid }
                        rate={ this.state.rate }
                        onRatingChange={ this.onRatingChange }
                        onRatingError={ this.onRatingError }
                        onRankChange={ this.onRankChange }
                        onHoursChange={ this.onHoursChange }
                        onValidChange={ this.onValidChange }
                        onRateChange={ this.onRateChange }
                    />
                    :
                    null
                }
                </CardText>
                <CardActions>
                    { this.state.add || this.state.edit ?
                        <SaveCancel
                            onSave={ this.save }
                            onCancel={ this.cancel }
                            disabled={ this.state.error }
                        />
                        :
                        <AddEditRemove
                            onAdd={ this.add }
                            onEdit={ this.edit }
                            onRemove={ this.remove }
                            disabled={ this.state.selectedRow === false }
                        />
                    }
                </CardActions>
            </Card>
        )
    }
}

PersonRating.propTypes = {
    data: PropTypes.object.isRequired, // immutable.List()
    type: PropTypes.string.isRequired,
    onAdd: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
}

export default PersonRating


/** WEBPACK FOOTER **
 ** ./src/components/person/Ratings/person-ratings.js
 **/